import React from 'react'
import PropTypes from 'prop-types'

import { utils, translate } from 'parking-react-common'

import { Field } from 'redux-form'

import { ui } from '../redux'

import Table from '../components/Table'
import Input from '../components/Input'
import Select from '../components/Select'
import Button from '../components/Button'
import TimePickerInput from '../components/TimePickerInput'

const WeeklyTimetableListForm = (props) => {
    const { fields, withPricing, t } = props
    const weekDayOptions = utils.label(['week-timetables', 'weekday'])

    const columns = [
        {
            key    : 'weekday',
            title  : t('Week Day'),
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Field
                    name={ `${fields.name}[${index}].weekday` }
                    placeholder={ t('Week Day') }
                    component={ Select }
                    options={ weekDayOptions }
                    size={ ui.SIZE.small }
                />
            )
        },
        {
            key    : 'start_time',
            title  : t('Opening Hours'),
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Field
                    name={ `${fields.name}[${index}].start_time` }
                    placeholder={ t('Opening Hours') }
                    component={ TimePickerInput }
                    size={ ui.SIZE.small }
                />
            )
        },
        {
            key    : 'stop_time',
            title  : t('Closing Hours'),
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Field
                    name={ `${fields.name}[${index}].stop_time` }
                    placeholder={ t('Closing Hours') }
                    component={ TimePickerInput }
                    size={ ui.SIZE.small }
                />
            )
        },
        withPricing && {
            key    : 'price',
            title  : t('Price'),
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Field
                    name={ `${fields.name}[${index}].price` }
                    placeholder={ t('Price') }
                    component={ Input }
                    size={ ui.SIZE.small }
                />
            )
        },
        {
            key    : 'delete',
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Button
                    onClick={ () => fields.remove(index) }
                    intent={ ui.INTENT.danger }
                    icon="md/delete"
                    isRounded
                />
            )
        }
    ]

    return (
        <Table
            columns={ columns }
            data={ fields.getAll() }
            withBorders={ false }
            footer={ (
                <Button
                    label={ t('Add Interval') }
                    icon="md/add"
                    size={ ui.SIZE.default }
                    intent={ ui.INTENT.primary }
                    onClick={ () => fields.push({
                        start_time : '00:00:00',
                        stop_time  : '23:59:59'
                    }) }
                    isRounded
                />
            ) }
        />
    )
}

WeeklyTimetableListForm.propTypes = {
    fields      : PropTypes.object.isRequired,
    withPricing : PropTypes.bool
}

WeeklyTimetableListForm.defaultProps = {
    withPricing: true
}

export default translate()(WeeklyTimetableListForm)
